<template>
  <div class="handHygieneConsumption">
    <!-- 导航栏 -->
    <nav-header head-title="上报详情"></nav-header>
    <!-- 轮播图 -->
    <!-- :autoplay="3000" -->
    <div class="container">
      <van-swipe
        class="my-swipe"
        indicator-color="#1C91FF"
        ref="swipe"
        @change="swipeChange"
      >
        <van-swipe-item v-for="(item, index) in dataList" :key="index">
          <div class="swipe-container-item">
            <div class="main-title">{{ comName }}</div>
            <div class="sub-title df-between">
              <img
                src="../../assets/images/monitorRecord/i-arrow-right.png"
                alt=""
                class="right img1"
                @click="nextPreview('prev')"
              />
              <!-- <span>{{ item.indexExplain }}</span> -->
              <span>{{ item.indexName }}</span>
              <img
                src="../../assets/images/monitorRecord/i-arrow-right.png"
                alt=""
                class="right"
                @click="nextPreview('next')"
              />
            </div>
          </div>
        </van-swipe-item>
      </van-swipe>
      <!-- 卡片容器 -->
      <div class="card-container">
        <div class="card" v-for="(item, index) in reportDataTree" :key="index">
          <!-- 标题 -->
          <div class="title-box" v-if="item.isShow">
            <div class="main-title df-between">
              <span class="name">{{ item.optionName }}</span>
              <span class="rate">{{ item.expressionVal }}</span>
            </div>
            <div class="sub-title">
              {{ item.optionTip }}
            </div>
          </div>
          <div v-for="(item2, index2) in item.children" :key="index2">
            <template v-if="item2.isShow">
              <!-- 填空 -->
              <div
                class="cell-item d-flex"
                v-if="item2.optionInputType == 2 || item2.optionInputType == 8"
              >
                <div class="title">{{ item2.optionName }}</div>
                <!-- value=value.replace(/[^\d]/g,'') > 200 ? 200 : value.replace(/[^\d]/g,'') -->
                <div class="field-span">
                  <van-field
                    v-model="item2.optionValue"
                    type="number"
                    class="va-input"
                    placeholder="请填写"
                    input-align="center"
                    max="10"
                    @input="handleInput($event, item2)"
                    :disabled="forbid"
                  />
                 </div>
                <!-- <input
              type="text"
              placeholder="请填写"
              oninput="value=value.replace(/[^\d]/g,'')"
              v-model="item2.optionValue"
              :disabled="forbid"
              :class="{ 'error-ipt': item2.errorFlag }"
            /> -->
                <div class="unit">{{ item2.unit }}</div>
              </div>
              <!-- 是否 -->
              <div class="cell-item d-flex" v-if="item2.optionInputType == 3">
                <van-radio-group
                  v-model="item2.optionValue"
                  direction="horizontal"
                  icon-size="18px"
                  :disabled="forbid"
                >
                  <van-radio name="1">是</van-radio>
                  <van-radio name="2">否</van-radio>
                </van-radio-group>
              </div>
              <!-- 有无 -->
              <div class="cell-item d-flex" v-if="item2.optionInputType == 1">
                <van-radio-group
                  v-model="radio"
                  direction="horizontal"
                  icon-size="18px"
                  :disabled="forbid"
                >
                  <van-radio name="1">有</van-radio>
                  <van-radio name="2">无</van-radio>
                </van-radio-group>
              </div>
              <!-- 错误提示 -->
              <div class="error-tip d-flex" v-if="item.errorFlag">
                <img src="../../assets/images/i-error.png" alt="" />
                <span>{{ item.ruleExplain }}</span>
              </div>
            </template>
          </div>

          <!-- 卡片占位 -->
          <div class="card-hodler" v-if="item.isShow"></div>
        </div>
      </div>
      <empty-component v-if="reportDataTree.length == 0 && loaded">
      </empty-component>
      <div class="holder"></div>
    </div>

    <!-- 操作按钮 -->
    <div class="btn-group df-center" @click="nextComDetail">下一个医院详情</div>

    <!-- 弹框 -->
    <!-- 提示弹框 -->
    <yd-popup
      v-model="ydPopShow"
      position="center"
      width="100%"
      :close-on-masker="false"
      class="ydPop"
    >
      <div class="yd-pop-inner">
        <img
          src="../../assets/images/monitorRecord/bg-gesture.png"
          alt=""
          class="bg-gesture"
        />
        <div class="m-dialog">左右滑动可在上报任务之间切换</div>
        <div class="df-center know-btn" @click="closePoP">关闭提示</div>
      </div>
    </yd-popup>
  </div>
</template>

<script>
import navHeader from "../../components/header/header.vue";
import emptyComponent from "../../components/empty-component/empty-component.vue";
import Vue from "vue";
import { mapState } from "vuex";
import { Swipe, SwipeItem } from "vant";
import { Popup } from "vue-ydui/dist/lib.rem/popup";
Vue.component(Popup.name, Popup);
Vue.use(Swipe);
Vue.use(SwipeItem);

export default {
  computed: {
    ...mapState({
      _userInfo: (state) => state.InvestorInfo,
    }),
  },
  components: {
    navHeader,
    emptyComponent,
  },
  data() {
    return {
      indexTypeList:[],
      comId: "",
      localYdPopShow: true,
      allComList: [],
      comName: "",
      loaded: false,
      ydPopShow: false,
      dataList: [],
      reportData: {},
      reportDataList: [],
      reportDataTree: [],
      radio: "1",
      headeName: "",
      forbid: true, // 禁用,
      fromPath: "",
    };
  },
  created() {
    this.indexTypeList = localStorage.getItem('indexTypeList').split(',')
    this.comName = this.$route.query.comName;
    this.comId = this.$route.query.comId;
    // 获取表列表
    this.getReportIndexList(() => {
      if (this.fromPath === "/" || this.fromPath === "/areaMonitorReport") {
        let localYdPopShow = localStorage.getItem("localYdPopShow");
        this.ydPopShow = true && !localYdPopShow;
        localStorage.setItem("localYdPopShow", true);
      }
    });
    // 获取已上报医院列表
    this.getComFinishCountList();
  },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      vm.fromPath = from.path;
      // vm.ydPopShow = from.path === "/" || from.path === "/areaMonitorReport";
    });
  },
  methods: {
    closePoP() {
      this.ydPopShow = false;
    },
    // 获取已上报/未上报医院列表
    getComFinishCountList(reportState = "1") {
      let params2 = {
        comId: this._userInfo.data.comId,
        userId: this._userInfo.data.userId,
        data: {
          taskId: this.$route.query.taskId,
          batch: this.$route.query.batch,
          comName: this.$route.query.keyword,
          reportState: reportState + "", // 1 已报 0 未报
          areaCode: this.$route.query.areaCode,
          page: 1,
          rows: 1000, // 需要获取所有的医院
        },
      };
      this.$http.getComFinishCountList(params2).then((res) => {
        console.log(res);
        if (res.code == 0) {
          let resArr = res.data ? res.data : [];
          this.allComList = resArr;
          console.log(resArr, "所有医院列表");
        } else {
          this.$toast(res.msg);
        }
      });
    },
    // 获取医院列表
    getReportIndexList(callback = false) {
      let params = {
        comId: this.comId,
        userId: this._userInfo.data.userId,
        data: { taskId: this.$route.query.taskId, indexTypeList: this.indexTypeList},
      };
      this.$http.getReportIndexList(params).then((res) => {
        if (res.code == 0) {
          this.dataList = res.data ? res.data : [];
          setTimeout(() => {
            if (this.dataList.length > 0) {
              this.getIndexResultDetailInfo(
                this.dataList[0].id,
                this.dataList[0].taskId,
                callback
              );
            }
          }, 100);
        }
        console.log(res, "7777");
      });
    },
    swipeChange(index) {
      console.log(index);
      console.log(this.dataList[index], "5456454");
      this.getIndexResultDetailInfo(
        this.dataList[index].id,
        this.dataList[index].taskId
      );
    },
    async nextComDetail() {
      console.log(this.comId);
      console.log(this.comId, 1111);
      let index = this.allComList.findIndex((v) => v.comId == this.comId);
      if (index > -1) {
        let nextIndex = index + 1;
        if (nextIndex >= this.allComList.length) {
          this.$toast("没有更多了");
          return;
        }
        await this.$refs.swipe.swipeTo(0);
        setTimeout(() => {
          this.comId = this.allComList[nextIndex].comId;
          this.comName = this.allComList[nextIndex].comName;
          this.getReportIndexList();
          console.log(index, "index///");
        }, 400);
      }
    },
    nextPreview(action) {
      this.$refs.swipe[action]();
    },
    // 获取报告列表数据
    getIndexResultDetailInfo(indexId, taskLinkId, callback) {
      let params = {
        comId: this.comId,
        userId: this._userInfo.data.userId,
        data: {
          taskId: this.$route.query.taskId,
          comId: this.comId,
          indexId: indexId,
          taskLinkId: taskLinkId,
          isPreface: "0",
        },
      };
      this.$http.getIndexResultDetailInfo(params).then((res) => {
        if (res.code === 0) {
          this.reportData = res.data;
          this.reportDataList = res.data.optionList;
          this.generatorReportTree(this.reportDataList);
          if (typeof callback === "function") {
            callback();
          }
          if (this.reportDataList.length == 0) {
            this.$toast("暂无数据");
          }
          this.loaded = true;
        } else {
          this.$toast(res.msg);
          this.loaded = true;
        }
      });
    },
    // 处理输入
    handleInput(e, item) {
      // 存在最大值
      item.optionValue = item.maxValue
        ? e > item.maxValue
          ? item.maxValue
          : e
        : e;
    },
    // 执行规则返回结果
    excuteRule(rule, reportList) {
      let newRule = rule;
      newRule = newRule.replace(/\(/g, "");
      newRule = newRule.replace(/\)/g, "");
      // 找key
      let keyArr = newRule.trim().split(/\+|\-|\==|\>=|\<=|\>|\<|\/|\*|\&&|\|/);
      let newKeyArr = [];
      keyArr.forEach((v, i) => {
        let str = v.trim();
        if (
          str &&
          isNaN(Number(v)) &&
          str.indexOf("%") === -1 &&
          str.indexOf("‰") === -1
        ) {
          newKeyArr.push(str);
        }
      });
      console.log(newKeyArr, "新校验规则key..");
      // 找value
      let keyObjArrValue = [];
      newKeyArr.forEach((v, i) => {
        console.log(v);
        let obj = reportList.find((v2) => v2.optionKey === v);
        if (obj) {
          keyObjArrValue.push(obj);
        }
      });
      console.log(keyObjArrValue, "值value....");
      // 替换规则
      newKeyArr.forEach((v, i) => {
        rule = rule.replace(
          new RegExp(v, "g"),
          keyObjArrValue[i].optionValue ? keyObjArrValue[i].optionValue : 0
        );
      });
      console.log(rule, "替换规则后的rule");
      // 执行规则
      let res = eval(rule);
      return res;
    },
    // 构建报告列表树
    generatorReportTree(reportList) {
      let newArr = [];
      reportList.forEach((v, i) => {
        // 1. 初始化自身显示隐藏
        if (v.showRule && v.showRule.length > 0) {
          let isShow = this.excuteRule(v.showRule, reportList);
          v.isShow = isShow;
        } else {
          v.isShow = true;
        }
        v.errorFlag = false;
        // 标题
        if (v.optionInputType == 6) {
          v.children = [];
          newArr.push(v);
        } else {
          if (newArr.length > 0 && newArr[newArr.length - 1].children) {
            newArr[newArr.length - 1].children.push(v);
          }
        }
      });
      this.reportDataTree = [...newArr];
      console.log(this.reportDataTree);
    },
  },
};
</script>

<style lang='scss' scoped>
.handHygieneConsumption {
  background-color: #f2f2f2;
  height: 100vh;
  font-size: 12px;
  display: flex;
  flex-direction: column;
  .container {
    flex: 1;
    overflow: scroll;
  }
  .card-container {
    .card {
      box-sizing: border-box;
      // padding: 15px 14px 20px 15px;
      padding: 0 14px 0 15px;
      background-color: #fff;
      margin-bottom: 10px;
      .title-box {
        padding-top: 15px;
        .main-title {
          .name {
            font-size: 16px;
            font-weight: 500;
            color: #333333;
            line-height: 22px;
          }
          .rate {
            font-size: 14px;
            color: rgb(51, 153, 255);
          }
        }
        .sub-title {
          margin-top: 5px;
          font-size: 14px;
          font-weight: 400;
          text-align: left;
          color: #999999;
          line-height: 20px;
        }
      }
      .cell-item {
        width: 100%;
        align-items: center;
        margin-top: 15px;
        height: 40px;
        margin-bottom: 10px;
        .title {
          text-align: left;
          width: 180px;
          flex: 1;
          font-size: 16px;
          font-weight: 500;
          color: #333333;
          line-height: 22px;
        }
        .field-span {
            margin: 0 5px;
            position: relative;
            border: 1px solid  #cccccc ;
            width: 115px;
            height: 38px;
            overflow: hidden;
            z-index: 10;
            display: flex;
            align-items: center;
            justify-content: center;
        }
        input,
        .va-input {
          flex: 1;
          // display: flex;
          // align-items: center;
          text-align: center;
          // width: 115px;
          // height: 35px;
          background: #ffffff;
          // border: 1px solid #cccccc ;
          // border-bottom: 1px solid #cccccc;
          font-size: 16px;
          // line-height: 40px;
          padding: 0;
          // padding-bottom: 5px;
          // text-align: center;
          // line-height: 22px;
        }
        // /deep/ .van-field__control {
        //   height: 115px;
        // }
        ::-webkit-input-placeholder {
          /* WebKit, Blink, Edge */
          color: #999999;
        }
        :-moz-placeholder {
          /* Mozilla Firefox 4 to 18 */
          color: #999999;
        }
        ::-moz-placeholder {
          /* Mozilla Firefox 19+ */
          color: #999999;
        }
        :-ms-input-placeholder {
          /* Internet Explorer 10-11 */
          color: #999999;
        }
        // .unit {
        //   margin-left: auto;
        //   font-size: 16px;
        //   color: #333333;
        // }
         .unit {
          // flex-shrink: 0;
          text-align: right;
          width: 50px;
          // flex-shrink: 0;
          margin-left: auto;
          font-size: 16px;
          color: #333333;
        }
      }
      .card-hodler {
        height: 20px;
        width: 100%;
      }
    }
  }
  .holder {
    height: 80px;
  }
  .btn-group {
    position: fixed;
    width: 100%;
    height: 60px;
    background: #ffffff;
    z-index: 99;
    bottom: 0;
    font-size: 18px;
    font-family: PingFangSC, PingFangSC-Regular;
    color: #1c91ff;
  }
  .my-swipe .van-swipe-item {
    color: #fff;
    height: 110px;
    font-size: 20px;
    text-align: center;
    background-color: #e5efff;
  }
  .my-swipe {
    margin-bottom: 10px;
  }
  .swipe-container-item {
    width: 100%;
    height: 100%;
    box-sizing: border-box;
    padding-top: 15px;
    .main-title {
      font-size: 18px;
      font-family: PingFangSC, PingFangSC-Medium;
      font-weight: 500;
      text-align: center;
      color: #333333;
      line-height: 25px;
    }
    .sub-title {
      width: 100%;
      box-sizing: border-box;
      padding: 0 15px;
      margin-top: 15px;
      img {
        width: 15px;
        height: 15px;
      }
      .img1 {
        transform: rotate(180deg);
      }
      span {
        font-size: 16px;
        font-family: PingFangSC, PingFangSC-Regular;
        font-weight: 400;
        text-align: center;
        color: #333333;
        line-height: 22px;
      }
    }
  }
  /deep/ .van-swipe__indicator {
    width: 8px;
    height: 8px;
    background-color: #ffffff;
    opacity: 1;
  }
  .error-ipt {
    border: 1px solid #ff4444 !important;
    color: #ff4444 !important;
    /deep/ .van-field__control {
      color: #ff4444;
    }
  }
  .error-tip {
    align-items: center;
    margin-top: 10;
    img {
      width: 14px;
      height: 14px;
      margin-right: 6px;
    }
    span {
      font-size: 14px;
      color: #ff4158;
    }
  }
  .ydPop {
    box-sizing: border-box;
    .yd-pop-inner {
      // padding-top: 120px;
      padding-bottom: 150px;
      // background-color: pink;
      .bg-gesture {
        // margin-top: 50px;
        margin: 0 auto;
        width: 236px;
        height: 138px;
        font-weight: 400;
      }
      .m-dialog {
        width: 206px;
        height: 83px;
        margin: 35px auto 0;
        box-sizing: border-box;
        background: url("../../assets/images/monitorRecord/bg-dialog.png");
        background-size: 100% 100%;
        padding: 22px 18px 0;
        font-size: 17px;
        color: #ffffff;
        line-height: 24px;
      }
      .know-btn {
        margin: 44px auto 0;
        width: 108px;
        height: 40px;
        opacity: 1;
        border: 1px solid #26b4ff;
        border-radius: 101px;
        font-size: 16px;
        color: #26b4ff;
      }
    }
  }
}
</style>